module.exports = __webpack_public_path__ + "static/fonts/Inter-TightRegular.6c7bcaa8.ttf";